export { default } from './components/EnableAutoCheckouts.component';



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/digital-auto-checkouts/index.js